module.exports = __webpack_public_path__ + "img/feature_d01.7361fadd.svg";